import { render, staticRenderFns } from "./CommonQuestionnaire.vue?vue&type=template&id=08750dde&"
import script from "./CommonQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./CommonQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports